export const FETCH_SCHOOL_SEARCH_REQUEST = 'FETCH_SCHOOL_SEARCH_REQUEST';
export const FETCH_SCHOOL_SEARCH_SUCCESS = 'FETCH_SCHOOL_SEARCH_SUCCESS';
export const FETCH_SCHOOL_SEARCH_FAILURE = 'FETCH_SCHOOL_SEARCH_FAILURE';
